import { render, staticRenderFns } from "./NumberFormatter.vue?vue&type=template&id=42771b17"
import script from "./NumberFormatter.vue?vue&type=script&lang=js"
export * from "./NumberFormatter.vue?vue&type=script&lang=js"
import style0 from "./NumberFormatter.vue?vue&type=style&index=0&id=42771b17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports